import { useContext } from 'react'

import { Box, Icon, Text } from '@fairfashion/design-system'

import { AuthContext } from '../../../../contexts/auth'
import { GlobalDataContext } from '../../../../contexts/globalData'
import { userHasPermission } from '../../../../utilities/menu/user-has-permission'

import * as Styles from './blockchain-card.styles'

export const BlockchainCard = () => {
  const { userType } = useContext(AuthContext)
  const { blockchainNetwork } = useContext(GlobalDataContext)

  const hasPermission =
    userType &&
    blockchainNetwork &&
    userHasPermission(userType, ['fashion_company', 'blockforce'])

  if (!hasPermission) {
    return null
  }

  return (
    <Styles.BlockchainCardWrapper
      padding={1}
      paddingX={2}
      borderRadius="16px"
      direction="column"
      gap={2}
      justifyContent="space-between"
      width="100%"
    >
      <Styles.StyledLink
        href={`${blockchainNetwork?.urlExplorer}?authInfo=${encodeURIComponent(JSON.stringify(blockchainNetwork?.explorerLogin))}`}
        target="_blank"
        rel="noreferrer"
      >
        <Box
          gap={2}
          alignItems="center"
          width="100%"
          justifyContent="space-between"
        >
          <Box alignItems="center" gap={2}>
            <Box backgroundColor="secondary" padding={1} borderRadius="12px">
              <Icon name="global" color="white" size={24} />
            </Box>
            <Text fontWeight="bold" color="white" size="small">
              Network
            </Text>
          </Box>
          <Icon name="arrow_right_up" color="white" size={20} />
        </Box>
      </Styles.StyledLink>
    </Styles.BlockchainCardWrapper>
  )
}
